/* eslint-disable no-unused-vars */
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Dropmenu, Search } from '../../Components';
import { Link, useNavigate } from 'react-router-dom';
import { useGetContractListQuery } from '../../Redux/Service/ContractApi';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { API_URL } from '../../Config/index';
import API from '../../Web/Instance';
import Loading from '../../Components/Loading';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import {
   setAllQuotations,
   setBankDetails,
   setContractPrefilledData,
   setOpportunities,
   setQuotation,
   setTechnologyStacks,
} from '../../Redux/Reducers/Contracts/ContractSlice';
import { getAuthToken } from '../../Redux/Service/FetchBaseQuery';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import StyledDashboardLayout from '../style';
import { useModuleHasPermissions } from '../../hooks/useModulePermissions';
// import PostAddIcon from '@mui/icons-material/PostAdd';

function ContractList() {
   // Assign flag to allow access to add/edit routes
   window.contractListSource = true;

   const [anchorEl, setAnchorEl] = useState(null);
   const [menuRow, setMenuRow] = useState(null);
   const [loading, setLoading] = useState(true);
   const navigate = useNavigate();
   // const [contractData, setContractData] = useState(null);
   const [searchQuery, setSearchQuery] = useState('');
   const [page, setPage] = useState(1);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [AccessToken, setAccessToken] = useState(null);
   const [copyingId, setCopyingId] = useState(null);
   const hasPermissions = useModuleHasPermissions('contract');

   const dispatch = useDispatch();
   const MySwal = withReactContent(Swal);
   React.useEffect(() => {
      setAccessToken(getAuthToken());
      const handle403 = (error, endpoint) => {
         if (error.response?.status === 403) {
            toast.error(`Access denied: You don't have permission to access ${endpoint}.`);
            // Optional: navigate('/unauthorized');
         } else {
            toast.error(`Something went wrong.`);
            console.error(`Error fetching ${endpoint}:`, error);
         }
      };

      API.get(`contract-content/contents`)
         .then((response) => {
            dispatch(setContractPrefilledData(response.data?.data));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'contract contents');
         });

      API.get(`technology-stack/list-technology`)
         .then((response) => {
            dispatch(setTechnologyStacks(response.data?.response));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'technology stacks');
         });

      API.get(`lead/list `)
         .then((response) => {
            dispatch(setOpportunities(response.data.response));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'leads');
         });

      API.get(`quotation/no-contract`, {
         headers: {
            Authorization: `Bearer ${getAuthToken()}`,
         },
      })
         .then((response) => {
            dispatch(setQuotation(response.data?.response));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'quotations');
         });

      API.get(`quotation/all`, {
         headers: {
            Authorization: `Bearer ${getAuthToken()}`,
         },
      })
         .then((response) => {
            dispatch(setAllQuotations(response.data?.response?.data));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'all quotations');
         });

      API.get(`contract-content/bank-detail`)
         .then((response) => {
            dispatch(setBankDetails(response.data?.data?.response));
         })
         .catch((error) => {
            setLoading(false);
            handle403(error, 'bank details');
         });
   }, [AccessToken, dispatch]);

   const {
      data: contract,
      refetch,
      isLoading,
      isError,
      error,
   } = useGetContractListQuery({
      limit: rowsPerPage,
      page: page,
      orderBy: 'DESC',
      search: searchQuery,
   });

   const customStyles = {
      rows: {
         style: {
            margin: '0px',
            padding: 0,
         },
      },
      headCells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontWeight: 600,
            fontSize: 16,
            background: '#3F30FF1A',
         },
      },
      cells: {
         style: {
            margin: '0px',
            padding: '10px 15px',
            fontSize: 15,
            fontWeight: 400,
            color: '#726E6E',
         },
      },
   };

   useEffect(() => {
      refetch();
   }, [refetch, searchQuery]);

   useEffect(() => {
      if (!isLoading && !isError) {
         // setContractData(contract?.response);
         setLoading(false);
      }
   }, [isLoading, isError, contract]);

   const handleEdit = (id) => {
      navigate(`/contract-edit/${id}`);
   };

   const handleView = (id) => {
      navigate(`/quotation/${id}`);
   };

   const handleSearch = (search) => {
      setSearchQuery(search);
      setPage(1);
   };

   const handleDelete = async (id) => {
      // handleMenuClose();
      const result = await MySwal.fire({
         title: 'Are you sure?',
         text: 'Are you sure you want to delete this contract?',
         icon: 'warning',
         showCancelButton: true,
         confirmButtonText: 'Yes, delete it!',
         cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) return;

      try {
         const response = await axios.post(
            `${API_URL}contract/delete/${id}`,
            {},
            {
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${getAuthToken()}`,
               },
            },
         );

         if (response.status === 200) {
            await MySwal.fire('Deleted!', 'Contract deleted successfully', 'success');
            refetch();
         } else {
            await MySwal.fire('Error', 'Failed to delete contract', 'error');
         }
      } catch (error) {
         console.error('Error deleting contract:', error);
         await MySwal.fire(
            'Denied!',
            error?.response?.data?.message || 'Error deleting contract',
            'error',
         );
      }
   };

   // Copy contract handler
   const handleCopy = async (id) => {
      if (!window.confirm('Are you sure you want to create a copy of this contract?')) return;
      try {
         setCopyingId(id);
         const response = await axios.post(
            `${API_URL}contract/copy/${id}`,
            {},
            {
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${getAuthToken()}`,
               },
            },
         );

         if (response?.data?.statusCode === 200) {
            toast.success(response.data.message || 'Contract copied successfully');
            // refresh list so new copy appears without page reload
            refetch();
         } else {
            toast.error(response?.data?.message || 'Failed to copy contract');
         }
      } catch (err) {
         console.error('Error copying contract:', err);
         toast.error(err?.response?.data?.message || 'Error copying contract');
      } finally {
         setCopyingId(null);
      }
   };

   const columns = [
      {
         name: 'SL No',
         cell: (row, index) => index + 1,
         button: false,
      },
      {
         name: 'Project Name',
         selector: (row) => row.projectName,
         sortable: true,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.projectName}</div>
         ),
      },
      {
         name: 'Opportunity',
         selector: (row) => row.opportunity?.name,
         sortable: true,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
               {row.opportunity?.name}
            </div>
         ),
      },
      {
         name: 'Created By',
         selector: (row) => row.user?.name,
         sortable: true,
         cell: (row) => {
            return (
               <div style={{ fontWeight: '500', color: '#495057' }}>{row.user?.name || 'N/A'}</div>
            );
         },
      },
      {
         name: 'Created On',
         selector: (row) => new Date(row.createdAt).toDateString(),
         sortable: true,
         width: '150px',
         cell: (row) => {
            return (
               <div
                  style={{
                     fontWeight: '500',
                     color: '#495057',
                     fontSize: '14px',
                     whiteSpace: 'nowrap',
                  }}
               >
                  {new Date(row.createdAt).toLocaleDateString('en-US', {
                     year: 'numeric',
                     month: 'short',
                     day: '2-digit',
                  })}
               </div>
            );
         },
      },
      {
         name: 'Last Update',
         selector: (row) => row.updatedAt,
         sortable: true,
         width: '150px',
         cell: (row) => {
            return (
               <div
                  style={{
                     fontWeight: '500',
                     color: '#6c757d',
                     fontSize: '14px',
                     whiteSpace: 'nowrap',
                  }}
               >
                  {row.updatedAt
                     ? new Date(row.updatedAt).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: '2-digit',
                       })
                     : 'N/A'}
               </div>
            );
         },
      },
      {
         name: 'Total Cost',
         selector: (row) => row.currency.symbol ?? 0,
         sortable: true,
         cell: (row) => {
            return (
               <div style={{ fontWeight: 'bold' }}>
                  {row?.currency?.symbol || ''}{' '}
                  {(Number(row.billableAmount) + Number(row.taxAmount)).toLocaleString()}
               </div>
            );
         },
      },
      {
         name: 'FILE',
         selector: (row) => (
            <div>
               <Link className="dark-link" to={API_URL + row.pdfPath} target="_blank" download>
                  <CloudDownloadIcon />
               </Link>
            </div>
         ),
      },
      {
         name: 'Action',
         cell: (row) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
               {/* <IconButton
            size="small"
            onClick={() => handleCopy(row.id)}
            title="Copy Contract"
            aria-label="copy-contract"
            disabled={copyingId === row.id}
          >
            <FileCopyOutlinedIcon fontSize="small" />
          </IconButton> */}
               <Dropmenu
                  className="dark-link"
                  handleEdit={() => handleEdit(row.id)}
                  handleDelete={() => handleDelete(row.id)}
                  // handleView={() => handleView(row.id)}
                  canEdit={hasPermissions?.canUpdate}
                  canDelete={hasPermissions?.canDelete}
               />
            </div>
         ),
         button: false,
      },
   ];

   if (loading) {
      return <Loading />;
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">Contract</h1>
                     </div>
                     {hasPermissions?.canAdd && (
                        <div className="btnWrap">
                           <Link to="/contract-add" className="btn addBtn">
                              <DocumentScannerIcon /> Create Contract
                           </Link>
                        </div>
                     )}
                  </div>
               </div>
            </div>
            <div className="card m-3 customCard">
               {isLoading ? (
                  <div>Loading...</div>
               ) : isError ? (
                  <div>Error: {error?.message}</div>
               ) : (
                  <div>
                     <Grid container spacing={2}>
                        <Grid item md={6} xs={12}></Grid>
                        <Grid item md={6} xs={12} display="flex" justifyContent="flex-end">
                           <Search onSearch={(query) => handleSearch(query)} />
                        </Grid>
                     </Grid>

                     <DataTable
                        columns={columns}
                        data={contract.response.data}
                        pagination
                        paginationServer
                        paginationTotalRows={contract.response.pagination.total}
                        paginationDefaultPage={page}
                        paginationPerPage={rowsPerPage}
                        onChangePage={setPage}
                        onChangeRowsPerPage={(newPerPage) => {
                           setRowsPerPage(newPerPage);
                           setPage(1);
                        }}
                        customStyles={customStyles}
                        className="dataTable"
                     />
                  </div>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   );
}

export default ContractList;
